import Picker from '../picker.vue'
import DatePickerPanel from '../panel/Date/date.vue'
import RangeDatePickerPanel from '../panel/Date/date-range.vue'

import { oneOf } from '../../../utils/assist'

export default {
  name: 'CalendarPicker',
  mixins: [Picker],
  props: {
    type: {
      validator(value) {
        return oneOf(value, [
          'year',
          'month',
          'montharea',
          'week',
          'weekrange',
          'date',
          'daterange',
          'datetime',
          'datetimerange',
        ])
      },
      default: 'date',
    },
  },
  components: { DatePickerPanel, RangeDatePickerPanel },
  computed: {
    panel() {
      const isRange = /range$/.test(this.type)
      return isRange ? 'RangeDatePickerPanel' : 'DatePickerPanel'
    },
    ownPickerProps() {
      return this.options
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/date-picker/picker/date-picker.js